
import { Component, Prop, Vue } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  ICountryConfig,
  ISolCommodityCounter,
  ISolCustomerCommodity,
  ISolCustomerCommodityType,
  ISolCustomerSupply,
} from "@/entities";
import SuppliesTable from "@/components/orders/SuppliesTable.vue";
import { Getter } from "vuex-class";

@Component({
  name: "supply-material-form",
  components: {
    SuppliesTable,
    Multiselect,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class SupplyMaterialForm extends Vue {
  @Getter("getCountryConfig") countryConfig!: ICountryConfig | undefined;
  @Prop({ required: true, default: [] })
  commodityTypes!: ISolCustomerCommodityType[];
  @Prop({ required: true, default: [] })
  supplies!: ISolCustomerSupply[];
  @Prop({ required: true, default: [] })
  servicePointId!: number;
  servicePointCounters!: ISolCommodityCounter[];
  commodityType: ISolCustomerCommodityType | null = null;
  commodity: ISolCustomerCommodity | null = null;
  supplyQuantity: number | null = null;

  constructor() {
    super();
  }

  mounted(): void {
    this.getServicePointCounters();
  }

  async getServicePointCounters(): Promise<void> {
    const res = await this.$services.solCustomer.orders?.getSupplyCounters(this.servicePointId);
    if (res) this.servicePointCounters = res;
  }

  get commodities(): ISolCustomerCommodity[] {
    this.commodity = null;
    return this.commodityType?.commodities || [];
  }

  get maximumQuantity(): number | undefined {
    return this.countryConfig?.Orders.Supply?.MaximumQuantity;
  }

  get maximumTotal(): number | undefined {
    if (!this.commodity) return undefined;

    const servicePointCounter = this.servicePointCounters.find(
      (c) => c.commodityId === this.commodity?.id
    );

    if (!servicePointCounter || servicePointCounter.maxQuantity === undefined) return undefined;

    const remainingTotal = servicePointCounter?.maxQuantity - (servicePointCounter?.counter ?? 0);
    return remainingTotal > 0 ? remainingTotal : 0;
  }

  addSupply(): void {
    const supply = {
      commodityTypeId: this.commodityType?.id,
      commodityTypeDescription: this.commodityType?.description,
      commodityId: this.commodity?.id,
      commodityDescription: this.commodity?.description,
      quantity: this.supplyQuantity,
    } as ISolCustomerSupply;

    let exists = false;
    this.supplies.forEach((s) => {
      if (s.commodityId === supply.commodityId) {
        s.quantity = supply.quantity;
        exists = true;
      }
    });

    if (!exists) {
      this.supplies.push(supply);
    }
    this.commodityType = null;
    this.commodity = null;
    this.supplyQuantity = null;
    const form = this.$refs.form as InstanceType<typeof ValidationObserver>;
    form.reset();
  }
}
